const Common = {
  Todo: "Common.Todo",
  Todo2: "Common.Todo2",
  TodoType_0: "Common.TodoType_0",
  TodoType_1: "Common.TodoType_1",
  TodoType_2: "Common.TodoType_2",
  TodoType_3: "Common.TodoType_3",
  TodoType_4: "Common.TodoType_4",
  TodoType_5: "Common.TodoType_5",
  TodoType_6: "Common.TodoType_6",
  TodoType_7: "Common.TodoType_7",
  TodoType_8: "Common.TodoType_8",
  TodoType_9: "Common.TodoType_9",
  TodoType_10: "Common.TodoType_10",
  TodoType_11: "Common.TodoType_11",
  TodoType_12: "Common.TodoType_12",
  TodoType_13: "Common.TodoType_13",
  TodoType_14: "Common.TodoType_14",
  TodoType_15: "Common.TodoType_15",
  TodoType_17: "Common.TodoType_17",
  TodoType_16: "Common.TodoType_16",
  TodoType_18: "Common.TodoType_18",
  TodoType_19: "Common.TodoType_19",
  TodoType_20: "Common.TodoType_20",
  TodoType_21: "Common.TodoType_21",
  TodoType_22: "Common.TodoType_22",
  TodoType_23: "Common.TodoType_23",
  TodoType_24: "Common.TodoType_24",
  TodoType_42: "Common.TodoType_42",
  TodoType_0_Description: "Common.TodoType_0_Description",
  TodoType_1_Description: "Common.TodoType_1_Description",
  TodoType_2_Description: "Common.TodoType_2_Description",
  TodoType_3_Description: "Common.TodoType_3_Description",
  TodoType_4_Description: "Common.TodoType_4_Description",
  TodoType_5_Description: "Common.TodoType_5_Description",
  TodoType_6_Description: "Common.TodoType_6_Description",
  TodoType_7_Description: "Common.TodoType_7_Description",
  TodoType_8_Description: "Common.TodoType_8_Description",
  TodoType_9_Description: "Common.TodoType_9_Description",
  TodoType_10_Description: "Common.TodoType_10_Description",
  TodoType_11_Description: "Common.TodoType_11_Description",
  TodoType_12_Description: "Common.TodoType_12_Description",
  TodoType_13_Description: "Common.TodoType_13_Description",
  TodoType_14_Description: "Common.TodoType_14_Description",
  TodoType_15_Description: "Common.TodoType_15_Description",
  TodoType_17_Description: "Common.TodoType_17_Description",
  TodoType_16_Description: "Common.TodoType_16_Description",
  TodoType_18_Description: "Common.TodoType_18_Description",
  TodoType_19_Description: "Common.TodoType_19_Description",
  TodoType_20_Description: "Common.TodoType_20_Description",
  TodoType_21_Description: "Common.TodoType_21_Description",
  TodoType_22_Description: "Common.TodoType_22_Description",
  TodoType_23_Description: "Common.TodoType_23_Description",
  TodoType_24_Description: "Common.TodoType_24_Description",
  Representation: "Common.Representation",
  Persons: "Common.Persons",
  AllInfo: "Common.AllInfo",
  ExcludingTax: "Common.ExcludingTax",
  PaymentStatus: "Common.PaymentStatus",
  OCR: "Common.OCR",
  Date: "Common.Date",
  DueDate: "Common.DueDate",
  Due_Date: "Common.Due_Date",
  Latest: "Common.Latest",
  ExpiryDate: "Common.ExpiryDate",
  BG_PG_IBAN: "Common.BG_PG_IBAN",
  StartDate: "Common.StartDate",
  LastDate: "Common.LastDate",
  MarkAsDone: "Common.MarkAsDone",
  ReferencePerson: "Common.ReferencePerson",
  Paid: "Common.Paid",
  Paid2: "Common.Paid2",
  Unpaid: "Common.Unpaid",
  Unpaid2: "Common.Unpaid2",
  Dimensions: "Common.Dimensions",
  Accrual: "Common.Accrual",
  Other: "Common.Other",
  Suggestions: "Common.Suggestions",
  Select: "Common.Select",
  SelectProperty: "Common.SelectProperty",
  SuggestionsMessage: "Common.SuggestionsMessage",
  Usual: "Common.Usual",
  All: "Common.All",
  Search: "Common.Search",
  Advanced: "Common.Advanced",
  Add: "Common.Add",
  Clear: "Common.Clear",
  AddDocument: "Common.AddDocument",
  DimensionSplitMessage: "Common.DimensionSplitMessage",
  View: "Common.View",
  ViewAll: "Common.ViewAll",
  ViewLess: "Common.ViewLess",
  Comment: "Common.Comment",
  Reply: "Common.Reply",
  TypeToReply: "Common.TypeToReply",
  Events: "Common.Events",
  Comments: "Common.Comments",
  Messages: "Common.Messages",
  ShowMore: "Common.ShowMore",
  ShowMore2: "Common.ShowMore2",
  ShowLess: "Common.ShowLess",
  Submit: "Common.Submit",
  Submit2: "Common.Submit2",
  Optional: "Common.Optional",
  Cancel: "Common.Cancel",
  Forward: "Common.Forward",
  ForwardToColleague: "Common.ForwardToColleague",
  ForwardToWhom: "Common.ForwardToWhom",
  Return: "Common.Return",
  SendBack: "Common.SendBack",
  ReturnWhy: "Common.ReturnWhy",
  Invoice: "Common.Invoice",
  Invoice2: "Common.Invoice2",
  EditPayment: "Common.EditPayment",
  EditPaymentMethod: "Common.EditPaymentMethod",
  PaymentSettings: "Common.PaymentSettings",
  PaymentMethodSettings: "Common.PaymentMethodSettings",
  SaveChanges: "Common.SaveChanges",
  Save: "Common.Save",
  Saved: "Common.Saved",
  NotAnInvoice: "Common.NotAnInvoice",
  Move: "Common.Move",
  NotAnInvoiceMessage: "Common.NotAnInvoiceMessage",
  Snooze: "Common.Snooze",
  Snoozed: "Common.Snoozed",
  SnoozeUntilWhen: "Common.SnoozeUntilWhen",
  Download: "Common.Download",
  DownloadAttachments: "Common.DownloadAttachments",
  Delete: "Common.Delete",
  Discard: "Common.Discard",
  Remove: "Common.Remove",
  Disable: "Common.Disable",
  DeleteWarningMessage: "Common.DeleteWarningMessage",
  WrongRecipientMessage: "Common.WrongRecipientMessage",
  NotSureWhatThisIsMessage: "Common.NotSureWhatThisIsMessage",
  Email: "Common.Email",
  MultipleEmailsHelpText: "Common.MultipleEmailsHelpText",
  Subject: "Common.Subject",
  QuickReply: "Common.QuickReply",
  IsAlreadyPaid: "Common.IsAlreadyPaid",
  PaymentDate: "Common.PaymentDate",
  PaymentDateChangeLabel: "Common.PaymentDateChangeLabel",
  Yes: "Common.Yes",
  No: "Common.No",
  Last12Months: "Common.Last12Months",
  LaterToday: "Common.LaterToday",
  Tomorrow: "Common.Tomorrow",
  LaterThisWeek: "Common.LaterThisWeek",
  ThisWeekend: "Common.ThisWeekend",
  NextWeek: "Common.NextWeek",
  Purpose: "Common.Purpose",
  Message: "Common.Message",
  Edit: "Common.Edit",
  Accept: "Common.Accept",
  AskForDimensions: "Common.AskForDimensions",
  EverythingCompletedMessage: "Common.EverythingCompletedMessage",
  CheckBeforePaymentMessage: "Common.CheckBeforePaymentMessage",
  FillInMissingMessage: "Common.FillInMissingMessage",
  Accounting: "Common.Accounting",
  DimensionCompatibilityType_1: "Common.DimensionCompatibilityType_1",
  DimensionCompatibilityType_2: "Common.DimensionCompatibilityType_2",
  DimensionCompatibilityType_3: "Common.DimensionCompatibilityType_3",
  DimensionCompatibilityType_4: "Common.DimensionCompatibilityType_4",
  DimensionCompatibilityType_5: "Common.DimensionCompatibilityType_5",
  DimensionCompatibilityType_6: "Common.DimensionCompatibilityType_6",
  DimensionCompatibilityType_7: "Common.DimensionCompatibilityType_7",
  DimensionCompatibilityType_8: "Common.DimensionCompatibilityType_8",
  DimensionCompatibilityType_9: "Common.DimensionCompatibilityType_9",
  DimensionCompatibilityType_10: "Common.DimensionCompatibilityType_10",
  DimensionCompatibilityType_11: "Common.DimensionCompatibilityType_11",
  DimensionCompatibilityType_12: "Common.DimensionCompatibilityType_12",
  DimensionCompatibilityType_13: "Common.DimensionCompatibilityType_13",
  ChooseNameLabel: "Common.ChooseNameLabel",
  Distribution: "Common.Distribution",
  UseDistribution: "Common.UseDistribution",
  SaveDistribution: "Common.SaveDistribution",
  SaveDistributionKey: "Common.SaveDistributionKey",
  DropFileOrClickMessage: "Common.DropFileOrClickMessage",
  BrowseMessage: "Common.BrowseMessage",
  DropFileMessage: "Common.DropFileMessage",
  FileFormatsMessage: "Common.FileFormatsMessage",
  TransactionList: "Common.TransactionList",
  Details: "Common.Details",
  Similar: "Common.Similar",
  General: "Common.General",
  Sender: "Common.Sender",
  Customer: "Common.Customer",
  Collection: "Common.Collection",
  Economy: "Common.Economy",
  Contacts: "Common.Contacts",
  Agreement: "Common.Agreement",
  OrgNo: "Common.OrgNo",
  Receiver: "Common.Receiver",
  Received: "Common.Received",
  CIN: "Common.CIN",
  RefersTo: "Common.RefersTo",
  Reference: "Common.Reference",
  Amount: "Common.Amount",
  AmountExVat: "Common.AmountExVat",
  AmountExVat2: "Common.AmountExVat2",
  ExVat: "Common.ExVat",
  InclVAT: "Common.InclVAT",
  VAT: "Common.VAT",
  AmountInclVAT: "Common.AmountInclVAT",
  Currency: "Common.Currency",
  OriginalCurrency: "Common.OriginalCurrency",
  Dates: "Common.Dates",
  InvoiceDate: "Common.InvoiceDate",
  PaymentDetails: "Common.PaymentDetails",
  Bankgiro: "Common.Bankgiro",
  OCRInvoiceNum: "Common.OCRInvoiceNum",
  PaymentTerms: "Common.PaymentTerms",
  IsCreditInvoice: "Common.IsCreditInvoice",
  Tags: "Common.Tags",
  TagsX: "Common.TagsX",
  TagsY: "Common.TagsY",
  TagsXExplanation: "Common.TagsXExplanation",
  TagsYExplanation: "Common.TagsYExplanation",
  Period: "Common.Period",
  PeriodiseWithDate: "Common.PeriodiseWithDate",
  PeriodiseWithDateInfo: "Common.PeriodiseWithDateInfo",
  SelectDates: "Common.SelectDates",
  SelectMonth: "Common.SelectMonth",
  PeriodiseOnDate: "Common.PeriodiseOnDate",
  PeriodiseWithDateLocked: "Common.PeriodiseWithDateLocked",
  MustSelectDateRange: "Common.MustSelectDateRange",
  Dashboard: "Common.Dashboard",
  Reports: "Common.Reports",
  Support: "Common.Support",
  Settings: "Common.Settings",
  Logout: "Common.Logout",
  PostedAs: "Common.PostedAs",
  Status: "Common.Status",
  State: "Common.State",
  TransactionText: "Common.TransactionText",
  Debit: "Common.Debit",
  Credit: "Common.Credit",
  SimilarSuggestionText: "Common.SimilarSuggestionText",
  ViewInvoice: "Common.ViewInvoice",
  Share: "Common.Share",
  Name: "Common.Name",
  NameAndSurname: "Common.NameAndSurname",
  Rating: "Common.Rating",
  Purchase: "Common.Purchase",
  Pc: "Common.Pc",
  MissingInfoMessage: "Common.MissingInfoMessage",
  SubmitSupportingDocs: "Common.SubmitSupportingDocs",
  SubmitSalaryDiviation: "Common.SubmitSalaryDiviation",
  AddReimbursement: "Common.AddReimbursement",
  NewMessage: "Common.NewMessage",
  SubmitDailyTakings: "Common.SubmitDailyTakings",
  AddDailyTakings: "Common.AddDailyTakings",
  CreateCustomerInvoice: "Common.CreateCustomerInvoice",
  Voucher: "Common.Voucher",
  Previous: "Common.Previous",
  Current: "Common.Current",
  Next: "Common.Next",
  LastModified: "Common.LastModified",
  Respond: "Common.Respond",
  NumOfYears: "Common.NumOfYears",
  NumOfWeeks: "Common.NumOfWeeks",
  NumOfMonths: "Common.NumOfMonths",
  NumOfDaysBefore: "Common.NumOfDaysBefore",
  NumOfDaysAfter: "Common.NumOfDaysAfter",
  NumOfHours: "Common.NumOfHours",
  NumOfMinutes: "Common.NumOfMinutes",
  NumOfDays: "Common.NumOfDays",
  Now: "Common.Now",
  Year: "Common.Year",
  YearPascal: "Common.YearPascal",
  Years: "Common.Years",
  Week: "Common.Week",
  Weeks: "Common.Weeks",
  Month: "Common.Month",
  MonthPascal: "Common.MonthPascal",
  Months: "Common.Months",
  MonthOrMonths: "Common.MonthOrMonths",
  Day: "Common.Day",
  DayPascal: "Common.DayPascal",
  Days: "Common.Days",
  DaysPascal: "Common.DaysPascal",
  Hour: "Common.Hour",
  Hours: "Common.Hours",
  HoursPascal: "Common.HoursPascal",
  Minute: "Common.Minute",
  Minutes: "Common.Minutes",
  MinutesPascal: "Common.MinutesPascal",
  YesterDay: "Common.YesterDay",
  Today: "Common.Today",
  Monthly: "Common.Monthly",
  Yearly: "Common.Yearly",
  Anytime: "Common.Anytime",
  CurrentYear: "Common.CurrentYear",
  LastYear: "Common.LastYear",
  LastUpdated: "Common.LastUpdated",
  CreatedBy: "Common.CreatedBy",
  Done: "Common.Done",
  ToComplete: "Common.ToComplete",
  Send: "Common.Send",
  ViewOlder: "Common.ViewOlder",
  Overdue: "Common.Overdue",
  SoonOverdue: "Common.SoonOverdue",
  You: "Common.You",
  SnoozeSuccessMessage: "Common.SnoozeSuccessMessage",
  Ago: "Common.Ago",
  InvoiceNo: "Common.InvoiceNo",
  AmountPaid: "Common.AmountPaid",
  LeftToPay: "Common.LeftToPay",
  Transactions: "Common.Transactions",
  SummaryShowsFilteredData: "Common.SummaryShowsFilteredData",
  Of: "Common.Of",
  Rows: "Common.Rows",
  AddEntity: "Common.AddEntity",
  Person: "Common.Person",
  Phone: "Common.Phone",
  PhoneNumber: "Common.PhoneNumber",
  Method: "Common.Method",
  DeliveryChannel: "Common.DeliveryChannel",
  TwoFactorAuthMethod: "Common.TwoFactorAuthMethod",
  ReferenceId: "Common.ReferenceId",
  UseByDefault: "Common.UseByDefault",
  Default: "Common.Default",
  PropertyDesignation: "Common.PropertyDesignation",
  Property: "Common.Property",
  Address: "Common.Address",
  NoResults: "Common.NoResults",
  StreetAddress: "Common.StreetAddress",
  StreetAddress2: "Common.StreetAddress2",
  PostalCode: "Common.PostalCode",
  PostalCodeShort: "Common.PostalCodeShort",
  City: "Common.City",
  Country: "Common.Country",
  Payment: "Common.Payment",
  OtherDetails: "Common.OtherDetails",
  Language: "Common.Language",
  OrgNr: "Common.OrgNr",
  NotFound: "Common.NotFound",
  OutOf: "Common.OutOf",
  Attachments: "Common.Attachments",
  FetchedFromRegister: "Common.FetchedFromRegister",
  NoEntitiesAdded: "Common.NoEntitiesAdded",
  None: "Common.None",
  InheritsFromMasterRow: "Common.InheritsFromMasterRow",
  EditInRRows: "Common.EditInRRows",
  From: "Common.From",
  To: "Common.To",
  Review: "Common.Review",
  FinalReview: "Common.FinalReview",
  Recurring: "Common.Recurring",
  SaveDraft: "Common.SaveDraft",
  Actions: "Common.Actions",
  Employees: "Common.Employees",
  Employee: "Common.Employee",
  Reset: "Common.Reset",
  FilterAction: "Common.FilterAction",
  Filter: "Common.Filter",
  ClearFilter: "Common.ClearFilter",
  TimePeriod: "Common.TimePeriod",
  Deviations: "Common.Deviations",
  EmployeesSalaryDeviations: "Common.EmployeesSalaryDeviations",
  DateFrom: "Common.DateFrom",
  DateTo: "Common.DateTo",
  Revenue: "Common.Revenue",
  Expenses: "Common.Expenses",
  MyProfile: "Common.MyProfile",
  Commission: "Common.Commission",
  Seller: "Common.Seller",
  Description: "Common.Description",
  Explanation: "Common.Explanation",
  Content: "Common.Content",
  Created: "Common.Created",
  Removed: "Common.Removed",
  InvoicedAmount: "Common.InvoicedAmount",
  UnpaidAmount: "Common.UnpaidAmount",
  SelectDate: "Common.SelectDate",
  LowestAmount: "Common.LowestAmount",
  HighestAmount: "Common.HighestAmount",
  TotalAmount: "Common.TotalAmount",
  Lowest: "Common.Lowest",
  Highest: "Common.Highest",
  Reject: "Common.Reject",
  Assign: "Common.Assign",
  UploadedBy: "Common.UploadedBy",
  Number: "Common.Number",
  PurchaseDate: "Common.PurchaseDate",
  CategoryRefers: "Common.CategoryRefers",
  PaymentMethod: "Common.PaymentMethod",
  SubmittedBy: "Common.SubmittedBy",
  PersonNumber: "Common.PersonNumber",
  Company: "Common.Company",
  ThisIsAutogenerated: "Common.ThisIsAutogenerated",
  MissingInformation: "Common.MissingInformation",
  RemainingValues: "Common.RemainingValues",
  Categories: "Common.Categories",
  Articles: "Common.Articles",
  StandardPrice: "Common.StandardPrice",
  Unit: "Common.Unit",
  VatRate: "Common.VatRate",
  StandardNumber: "Common.StandardNumber",
  FreeText: "Common.FreeText",
  Owner: "Common.Owner",
  Deadline: "Common.Deadline",
  AutoApprovals: "Common.AutoApprovals",
  ReferTo: "Common.ReferTo",
  RowsPerPage: "Common.RowsPerPage",
  NotSelected: "Common.NotSelected",
  CompanyName: "Common.CompanyName",
  PG_BG: "Common.PG_BG",
  Automation: "Common.Automation",
  Interval: "Common.Interval",
  Attach: "Common.Attach",
  VATAmount: "Common.VATAmount",
  VATFree: "Common.VATFree",
  VatRateLockedNotVatRegistered: "Common.VatRateLockedNotVatRegistered",
  OpenOldWint: "Common.OpenOldWint",
  QuickFilter: "Common.QuickFilter",
  CreditRating: "Common.CreditRating",
  RecurringInvoices: "Common.RecurringInvoices",
  NumOfRecurringInvoices: "Common.NumOfRecurringInvoices",
  NumOfInvoices: "Common.NumOfInvoices",
  Invoicing: "Common.Invoicing",
  IsActive: "Common.IsActive",
  Active: "Common.Active",
  Active2: "Common.Active2",
  InActive: "Common.InActive",
  InActive2: "Common.InActive2",
  Activate: "Common.Activate",
  Deactivate: "Common.Deactivate",
  Disabled: "Common.Disabled",
  MarkAsDefault: "Common.MarkAsDefault",
  InTotal: "Common.InTotal",
  NavigationHelpText: "Common.NavigationHelpText",
  NavigationContentHelpText: "Common.NavigationContentHelpText",
  SpeedDialHelpText: "Common.SpeedDialHelpText",
  SpeedDialContentHelpText: "Common.SpeedDialContentHelpText",
  NotificationHelpText: "Common.NotificationHelpText",
  NotificationContentHelpText: "Common.NotificationContentHelpText",
  FirstIntroductionContent: "Common.FirstIntroductionContent",
  ProTip: "Common.ProTip",
  FirstIntroductionTip: "Common.FirstIntroductionTip",
  FirstIntroductionConfirmText: "Common.FirstIntroductionConfirmText",
  SecondIntroductionContent: "Common.SecondIntroductionContent",
  FaqButton: "Common.FaqButton",
  Faq: "Common.Faq",
  FaqText: "Common.FaqText",
  ReferFriendWidgetButton: "Common.ReferFriendWidgetButton",
  GotItButton: "Common.GotItButton",
  SecondIntroductionTitle: "Common.SecondIntroductionTitle",
  FirstIntroductionTitle: "Common.FirstIntroductionTitle",
  Inactivate: "Common.Inactivate",
  AutomaticApproval: "Common.AutomaticApproval",
  Create: "Common.Create",
  NameType: "Common.NameType",
  Credited: "Common.Credited",
  Accumulated: "Common.Accumulated",
  Sent: "Common.Sent",
  Type: "Common.Type",
  Counterpart: "Common.Counterpart",
  Open: "Common.Open",
  ToApprove: "Common.ToApprove",
  ComingSoon: "Common.ComingSoon",
  DueDateFormatter: "Common.DueDateFormatter",
  CreatedDateFormatter: "Common.CreatedDateFormatter",
  TransactionDateFormatter: "Common.TransactionDateFormatter",
  Salary: "Common.Salary",
  AccumulatedOperatingProfit: "Common.AccumulatedOperatingProfit",
  OperatingProfit: "Common.OperatingProfit",
  Sale: "Common.Sale",
  Frequency_Daily: "Common.Frequency_Daily",
  Frequency_Monthly: "Common.Frequency_Monthly",
  Frequency_Quarterly: "Common.Frequency_Quarterly",
  Frequency_Yearly: "Common.Frequency_Yearly",
  AverageMonth: "Common.AverageMonth",
  Difference: "Common.Difference",
  RemoveColumn: "Common.RemoveColumn",
  EmailSupport: "Common.EmailSupport",
  Shortcuts: "Common.Shortcuts",
  Welcome: "Common.Welcome",
  WelcomeMessage: "Common.WelcomeMessage",
  ReferFriendWidget: "Common.ReferFriendWidget",
  ReferFriendWidgetSummer2026: "Common.ReferFriendWidgetSummer2026",
  ReferFriendWidgetMessageSummer2026: "Common.ReferFriendWidgetMessageSummer2026",
  ReferFriendWidgetButtonSummer2026: "Common.ReferFriendWidgetButtonSummer2026",
  ReferFriendWidgetMessage: "Common.ReferFriendWidgetMessage",
  NoEvents: "Common.NoEvents",
  MainChart_0: "Common.MainChart_0",
  MainChart_1: "Common.MainChart_1",
  MainChart_2: "Common.MainChart_2",
  MainChart_3: "Common.MainChart_3",
  CostReductionChartTitle: "Common.CostReductionChartTitle",
  BankBalance: "Common.BankBalance",
  BankBalanceAsOf: "Common.BankBalanceAsOf",
  BankBalanceStale: "Common.BankBalanceStale",
  BankBalanceNothingToShowTitle: "Common.BankBalanceNothingToShowTitle",
  BankBalanceNothingToShowDescription: "Common.BankBalanceNothingToShowDescription",
  BankBalanceCouldNotLoadTitle: "Common.BankBalanceCouldNotLoadTitle",
  BankBalanceCouldNotLoadDescription: "Common.BankBalanceCouldNotLoadDescription",
  Staff: "Common.Staff",
  Features: "Common.Features",
  Salaries: "Common.Salaries",
  Payments: "Common.Payments",
  WintSettings: "Common.WintSettings",
  Generally: "Common.Generally",
  Receipts: "Common.Receipts",
  And: "Common.And",
  User: "Common.User",
  Changed: "Common.Changed",
  Change: "Common.Change",
  Integrations: "Common.Integrations",
  Integration: "Common.Integration",
  System: "Common.System",
  Month_1: "Common.Month_1",
  Month_2: "Common.Month_2",
  Month_3: "Common.Month_3",
  Month_4: "Common.Month_4",
  Month_5: "Common.Month_5",
  Month_6: "Common.Month_6",
  Month_7: "Common.Month_7",
  Month_8: "Common.Month_8",
  Month_9: "Common.Month_9",
  Month_10: "Common.Month_10",
  Month_11: "Common.Month_11",
  Month_12: "Common.Month_12",
  MonthShort_1: "Common.MonthShort_1",
  MonthShort_2: "Common.MonthShort_2",
  MonthShort_3: "Common.MonthShort_3",
  MonthShort_4: "Common.MonthShort_4",
  MonthShort_5: "Common.MonthShort_5",
  MonthShort_6: "Common.MonthShort_6",
  MonthShort_7: "Common.MonthShort_7",
  MonthShort_8: "Common.MonthShort_8",
  MonthShort_9: "Common.MonthShort_9",
  MonthShort_10: "Common.MonthShort_10",
  MonthShort_11: "Common.MonthShort_11",
  MonthShort_12: "Common.MonthShort_12",
  Start: "Common.Start",
  Stop: "Common.Stop",
  Total: "Common.Total",
  Incoming: "Common.Incoming",
  Incoming2: "Common.Incoming2",
  BasicInformation: "Common.BasicInformation",
  Responsible: "Common.Responsible",
  DisableRowTooltip: "Common.DisableRowTooltip",
  Copy: "Common.Copy",
  CopyLink: "Common.CopyLink",
  TotalRevenue: "Common.TotalRevenue",
  IncomingInvoices: "Common.IncomingInvoices",
  WhatDoYouWantToDo: "Common.WhatDoYouWantToDo",
  Periodically: "Common.Periodically",
  PayoutDate: "Common.PayoutDate",
  AlreadyPaid: "Common.AlreadyPaid",
  Sign: "Common.Sign",
  BankIdProcessing: "Common.BankIdProcessing",
  Approved: "Common.Approved",
  Loading: "Common.Loading",
  NoDataAvailable: "Common.NoDataAvailable",
  Quotation: "Common.Quotation",
  Continue: "Common.Continue",
  PaymentInformation: "Common.PaymentInformation",
  ReceiptPaymentInformation: "Common.ReceiptPaymentInformation",
  Image: "Common.Image",
  MoreInfo: "Common.MoreInfo",
  EndDate: "Common.EndDate",
  Account: "Common.Account",
  AccountName: "Common.AccountName",
  ExpandAllRows: "Common.ExpandAllRows",
  CollapseAllRows: "Common.CollapseAllRows",
  ExportToExcel: "Common.ExportToExcel",
  ExportToCSV: "Common.ExportToCSV",
  Etc: "Common.Etc",
  SomethingIsMissingReviewAgain: "Common.SomethingIsMissingReviewAgain",
  SelectPhotos: "Common.SelectPhotos",
  Saving: "Common.Saving",
  DontSave: "Common.DontSave",
  More: "Common.More",
  Approve: "Common.Approve",
  FinalApproval: "Common.FinalApproval",
  NotApproved: "Common.NotApproved",
  Project: "Common.Project",
  By: "Common.By",
  Urgency: "Common.Urgency",
  Urgency2: "Common.Urgency2",
  WeekPascal: "Common.WeekPascal",
  FinancialStatements: "Common.FinancialStatements",
  DownPaymentVisibility_0: "Common.DownPaymentVisibility_0",
  DownPaymentVisibility_1: "Common.DownPaymentVisibility_1",
  Agent: "Common.Agent",
  ReadMore: "Common.ReadMore",
  Versions: "Common.Versions",
  Version: "Common.Version",
  DebtCollection: "Common.DebtCollection",
  Information: "Common.Information",
  K10Forms: "Common.K10Forms",
  SearchDimension: "Common.SearchDimension",
  UnevenSplit: "Common.UnevenSplit",
  AddUser: "Common.AddUser",
  Roles: "Common.Roles",
  CreateSupport: "Common.CreateSupport",
  HelpTitle: "Common.HelpTitle",
  HelpDescription: "Common.HelpDescription",
  MeetTheTeam: "Common.MeetTheTeam",
  YourEconomyTeam: "Common.YourEconomyTeam",
  SendMessage: "Common.SendMessage",
  FaqSubtitle: "Common.FaqSubtitle",
  SendMessageSubtitle: "Common.SendMessageSubtitle",
  CallSupport: "Common.CallSupport",
  CallSupportSubtitle: "Common.CallSupportSubtitle",
  GetPersonalAdvice: "Common.GetPersonalAdvice",
  BookMeeting: "Common.BookMeeting",
  ExternalAdvisorDescription: "Common.ExternalAdvisorDescription",
  AllNews: "Common.AllNews",
  GoodJob: "Common.GoodJob",
  AllCompletedText: "Common.AllCompletedText",
  UrgentStateTitle: "Common.UrgentStateTitle",
  UrgentStateText: "Common.UrgentStateText",
  DeadlineBannerTitle: "Common.DeadlineBannerTitle",
  DeadlineBannerDescription: "Common.DeadlineBannerDescription",
  TipDialogTitle: "Common.TipDialogTitle",
  TipDialogDescription: "Common.TipDialogDescription",
  TipDialogFieldLabel: "Common.TipDialogFieldLabel",
  TipDialogButtonText: "Common.TipDialogButtonText",
  TipDialogTitleSummer2026: "Common.TipDialogTitleSummer2026",
  TipDialogDescriptionSummer2026: "Common.TipDialogDescriptionSummer2026",
  TipDialogValiditySummer2026: "Common.TipDialogValiditySummer2026",
  TipDialogOfferLabel: "Common.TipDialogOfferLabel",
  NewEntity: "Common.NewEntity",
  Tag: "Common.Tag",
  DownloadAsPDF: "Common.DownloadAsPDF",
  Export: "Common.Export",
  HandledBy: "Common.HandledBy",
  FileUploadError: "Common.FileUploadError",
  PrintDate: "Common.PrintDate",
  FormExitWarningMessage: "Common.FormExitWarningMessage",
  FormExitWarningMessageDescription: "Common.FormExitWarningMessageDescription",
  FormExitWarningMessage2: "Common.FormExitWarningMessage2",
  Close: "Common.Close",
  CloseForm: "Common.CloseForm",
  ContinueEditing: "Common.ContinueEditing",
  RegisterTime: "Common.RegisterTime",
  SSNOrOrgNr: "Common.SSNOrOrgNr",
  Quantity: "Common.Quantity",
  Value: "Common.Value",
  ShareType: "Common.ShareType",
  CheckInformation: "Common.CheckInformation",
  ApprovedBy: "Common.ApprovedBy",
  Answer: "Common.Answer",
  AddFile: "Common.AddFile",
  BookWithoutImage: "Common.BookWithoutImage",
  BookedAs: "Common.BookedAs",
  InfoFromWint: "Common.InfoFromWint",
  Consequences: "Common.Consequences",
  FinancialYear: "Common.FinancialYear",
  FinancialYear2: "Common.FinancialYear2",
  AttachedFiles: "Common.AttachedFiles",
  LoadMore: "Common.LoadMore",
  DownloadSpecification: "Common.DownloadSpecification",
  MarkAsSigned: "Common.MarkAsSigned",
  Users: "Common.Users",
  ExportReportProgress: "Common.ExportReportProgress",
  DateRange: "Common.DateRange",
  Snapshot: "Common.Snapshot",
  AreYouSure: "Common.AreYouSure",
  CancelScheduledChangesConfirmation: "Common.CancelScheduledChangesConfirmation",
  Text: "Common.Text",
  AnswerBefore: "Common.AnswerBefore",
  Deny: "Common.Deny",
  OpenAccountSpecification: "Common.OpenAccountSpecification",
  Processing: "Common.Processing",
  Error: "Common.Error",
  ExportedFiles: "Common.ExportedFiles",
  ExportedFilesDescription: "Common.ExportedFilesDescription",
  OnlyMine: "Common.OnlyMine",
  QueueExport: "Common.QueueExport",
  QueueExportSuccess: "Common.QueueExportSuccess",
  RatingButtonTitle: "Common.RatingButtonTitle",
  Searching: "Common.Searching",
  Help: "Common.Help",
  ContactDetails: "Common.ContactDetails",
  BeforeYouClose: "Common.BeforeYouClose",
  HandledManually: "Common.HandledManually",
  MarkAsSentIn: "Common.MarkAsSentIn",
  NotAvailable: "Common.NotAvailable",
  OK: "Common.OK",
  Summation: "Common.Summation",
  Upload: "Common.Upload",
  CSVFile: "Common.CSVFile",
  ColumnLowerCase: "Common.ColumnLowerCase",
  SelectColumn: "Common.SelectColumn",
  Delayed: "Common.Delayed",
  AuditorReportSign: "Common.AuditorReportSign",
  MultipleRecipientsToolTip: "Common.MultipleRecipientsToolTip",
  MultipleRecipientsMessage: "Common.MultipleRecipientsMessage",
  AgencyMultipleRecipientsToolTip: "Common.AgencyMultipleRecipientsToolTip",
  ConfidentialCaseToolTip: "Common.ConfidentialCaseToolTip",
  ConfidentialCaseMessage: "Common.ConfidentialCaseMessage",
  ConfidentialMultipleRecipientsToolTip: "Common.ConfidentialMultipleRecipientsToolTip",
  ConfidentialMultipleRecipientsMessage: "Common.ConfidentialMultipleRecipientsMessage",
  ForwardConfidentialWarningTitle: "Common.ForwardConfidentialWarningTitle",
  ForwardConfidentialWarning: "Common.ForwardConfidentialWarning",
  ForwardConfidentialWarningNote: "Common.ForwardConfidentialWarningNote",
  Participants: "Common.Participants",
  GoToSigning: "Common.GoToSigning",
  AmountExVatHelpText: "Common.AmountExVatHelpText",
  ConfirmSigning: "Common.ConfirmSigning",
  InheritsStandard: "Common.InheritsStandard",
  OverridesStandard: "Common.OverridesStandard",
  Override: "Common.Override",
  InheritStandard: "Common.InheritStandard",
  NotSet: "Common.NotSet",
  Source: "Common.Source",
  Percentage: "Common.Percentage",
  Receipt: "Common.Receipt",
  IncomingInvoice: "Common.IncomingInvoice",
  GenericDocument: "Common.GenericDocument",
  Unknown: "Common.Unknown",
  MissingDocument: "Common.MissingDocument",
  SelfInvoice: "Common.SelfInvoice",
  Uncategorized: "Common.Uncategorized",
  Info: "Common.Info",
  Uploaded: "Common.Uploaded",
  AttachFiles: "Common.AttachFiles",
  Glenn: "Common.Glenn",
  ReplyLatest: "Common.ReplyLatest",
  Images: "Common.Images",
  LeftToPeriodise: "Common.LeftToPeriodise",
  PeriodisationModeLockedToFirstRow: "Common.PeriodisationModeLockedToFirstRow",
  PeriodisationRowsMustCoverAmount: "Common.PeriodisationRowsMustCoverAmount",
  AddPeriod: "Common.AddPeriod",
  RemovePeriod: "Common.RemovePeriod",
  Confirm: "Common.Confirm",
  PeriodisationStatusCleared: "Common.PeriodisationStatusCleared",
  PeriodisationStatusComplete: "Common.PeriodisationStatusComplete",
  PeriodisationStatusIncomplete: "Common.PeriodisationStatusIncomplete",
  PeriodisationStatusOverAllocated: "Common.PeriodisationStatusOverAllocated",
  PeriodisationAllInInvoiceMonth: "Common.PeriodisationAllInInvoiceMonth",
  }
export default Common;